import { useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { createCheckoutSession } from '../services/PricingTableService'
import useAxiosPrivate from '../../../hooks/useAxiosPrivate'
import { CREDIT_AMOUNT, TRIAL_PERIOD_DAYS } from '../../../data'

export default function usePricingTable({
    subscriptionsData,
    token,
    reinstate,
    handleCancel,
    disabled,
}) {
    // Group subscription data by interval
    function handleData(data) {
        const group = {}
        data.forEach((dataItem) => {
            group[dataItem.recurring.interval] ||= []
            group[dataItem.recurring.interval].push(dataItem)
        })
        return group
    }

    const data = handleData(subscriptionsData)
    const [duration, setDuration] = useState('month')
    const [chosenSubId, setChosenSubId] = useState(data[duration][0]?.id)
    const testMode = process.env.NODE_ENV !== 'production'
    const saveAmount = (data.month[0].unit_amount * 12 - data.year[0].unit_amount) / 100
    const [message, setMessage] = useState(null)
    const axiosPrivate = useAxiosPrivate()

    const subscriptionIncludes = [
        `${TRIAL_PERIOD_DAYS} day free initial trial${reinstate ? ': TRIAL USED' : ''}`,
        'View/ Create / Like activities, places to eat, shop etc.',
        `For every entry added, recieve A$0.${CREDIT_AMOUNT} credit to your account`,
        'View/ Create/ Like comments',
        'Check-in to ports and see others who have checked in',
        'Cancel at any time',
    ]

    const handleChange = (event, newDuration) => {
        if (newDuration !== null) {
            setDuration(newDuration)
            setChosenSubId(data[newDuration][0].id)
        }
    }

    // TanStack Query mutation for checkout session
    const checkoutMutation = useMutation({
        mutationFn: async () => {
            return await createCheckoutSession({
                token,
                price: chosenSubId,
                axiosPrivate,
            })
        },
        onSuccess: (response) => {
            if (!response) throw new Error('Error creating checkout session')
            window.location = response.stripeUrl
        },
        onError: (error) => {
            setMessage({
                type: 'Checkout Error',
                text: `Error creating checkout session: ${error.message}`,
            })
        },
    })

    function handleCheckoutClick() {
        checkoutMutation.mutate()
    }

    return {
        data,
        duration,
        setDuration,
        chosenSubId,
        setChosenSubId,
        testMode,
        saveAmount,
        message,
        setMessage,
        subscriptionIncludes,
        handleChange,
        checkoutMutation,
        handleCheckoutClick,
        handleCancel,
        disabled,
        reinstate,
    }
}
